import { mockFetch } from '../../../../utils/fetchMock';
import {
  getFastspringCheckPaymentUrl,
  getFastspringOrderUrl,
  getFlexibleTokenUrl,
  getPackagesApiUrl,
} from '../../../../utils/links';
import { PopupModeService } from '../../../../services/popupModeService';
import { PlansIds, PRODUCTS } from '../../../../constants/config';
import { getOriginQueryParam } from 'services/queryParamsService';
import { pickProperty } from 'utils/helpers';
import { navigateTo } from 'utils/navigateTo';

const MOCK_PACKAGES = process.env.NODE_ENV === 'development';

const requestJSON = link => fetch(link, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Cache: 'no-cache',
  },
  credentials: 'include',
})
  .then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw Error('can\'t load json');
  });

const mockedPackages = {
  '4': { 'monthlyPrice': 29.99, 'yearlyMonthlyPrice': 24.99 },
  '5': { 'monthlyPrice': 44.99, 'yearlyMonthlyPrice': 37.5, 'isDisabled': true },
  '11': { 'yearlyMonthlyPrice': 33.33 },
  '12': { 'yearlyMonthlyPrice': 44.44 },
};

export const getPlansPrices = () => {
  if (MOCK_PACKAGES) {
    return mockFetch(JSON.stringify(mockedPackages), 1000).then(response => response.json());
  } else {
    return requestJSON(getPackagesApiUrl());
  }
};

export const checkPayment = (userId) => {
  const isPopupMode = PopupModeService.isPopupMode();

  return fetch(getFastspringCheckPaymentUrl(userId), {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then(res => {
    if (res.ok) {
      res.json().then(data => {
        if (isPopupMode) {
          PopupModeService.upgradeComplete();
        } else if (data.redirect) {
          navigateTo(data.redirect);
        }
      });
    }
  }).catch(function(err) {
    console.info(err);
  });
};

export function fastspringOrder(orderId) {
  fetch(getFastspringOrderUrl(orderId), {
    method: 'POST',
    credentials: 'include',
  });
}

export const sendChoosePlanRequest = (planId, isAnnuallyPlan, isRedirect = true) => {
  return requestJSON(getFlexibleTokenUrl(planId, isAnnuallyPlan))
    .then((result) => {
      if (isRedirect) {
        navigateTo(result.redirect || '');
      }
    });
};

export const getSelectedPlan = () => {
  if (!PopupModeService.isPopupMode()) {
    return PlansIds.STANDARD_PLUS;
  }

  const feature = getOriginQueryParam();
  const availablePlans = PRODUCTS
    .filter(pickProperty('planId'))
    .filter(plan => plan.features && plan.features.includes(feature));

  return availablePlans.length ? Math.min(...availablePlans.map(plan => plan.planId)) : PlansIds.STANDARD_PLUS;
};
